var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"rounded-lg",attrs:{"show":"","variant":"danger"}},[_c('p',{staticClass:"text-white"},[_c('strong',[_vm._v("ERROR:")]),_c('br'),_vm._v(" "+_vm._s(_vm.error)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }